import * as React from 'react';
import { observer } from 'mobx-react';
import { configConsumer } from '@estee/elc-service';
import { gridItemType } from '~constants/ProductGrid';
import { ComponentTypes } from '~constants/ComponentTypes';
import { CollectionItem, CollectionItemType } from '../product-grid/CollectionItem';
import { IProductBriefCollectionConfig } from './ProductBriefCollection';
import { IOrderConfigCollection } from '~interfaces/IOrderableComponents';
import { GridItem } from '~domain/entities/GridItem';
import { IBreakpoints } from '~interfaces/IBreakpoints';

const ITEMS_CLASSNAME = 'js-grid-styled-column';

export interface IProductBriefItem {
    breakpoints?: IBreakpoints;
    config?: IProductBriefItemConfig;
    gridItem: GridItem;
    isMobile?: boolean;
    isLoaded: boolean;
    areFiltersApplied?: boolean;
}

interface IProductBriefItemConfig {
    componentElementsOrderConfig?: { [key: string]: IOrderConfigCollection };
    featuredProductOverrideImage?: string;
}

@configConsumer(['componentElementsOrderConfig', 'featuredProductOverrideImage'])
@observer
export class ProductBriefItem extends React.Component<IProductBriefItem> {
    private getOverrideImage(item: GridItem, imageOverride?: string) {
        if (item.itemType !== gridItemType.featuredProduct || !imageOverride) {
            return '';
        }

        return imageOverride;
    }

    private isFeatured(gridItem: GridItem) {
        return !this.props.areFiltersApplied
            ? gridItem.itemType === gridItemType.featuredProduct
            : false;
    }

    private getBriefProps(gridItem: GridItem) {
        const { featuredProductOverrideImage } = this.props.config as IProductBriefItemConfig;
        const { isLoaded } = this.props;

        return {
            key: `column-for-${gridItem.itemId}`,
            className: ITEMS_CLASSNAME,
            positionIndex: gridItem.positionIndex,
            imageOverride: this.getOverrideImage(gridItem, featuredProductOverrideImage),
            isFeatured: this.isFeatured(gridItem),
            isLoaded,
            isMobile: this.props.isMobile,
            componentType: ComponentTypes.PRODUCT_BRIEF
        };
    }

    render() {
        const { componentElementsOrderConfig } = this.props.config as IProductBriefCollectionConfig;
        const { gridItem, breakpoints } = this.props;
        const lazyLoadImageMobile = gridItem.positionIndex >= Number(breakpoints?.numColumnsMobile);
        const lazyLoadImageDesktop =
            gridItem.positionIndex >= Number(breakpoints?.numColumnsDesktop);

        switch (gridItem.itemType) {
            case gridItemType.product:
            case gridItemType.featuredProduct:
                return (
                    gridItem.product && (
                        <CollectionItem
                            collectionItem={CollectionItemType.PRODUCT}
                            id={gridItem.itemId}
                            productBriefProps={{
                                ...this.getBriefProps(gridItem),
                                product: gridItem.product,
                                lazyLoadImageMobile,
                                lazyLoadImageDesktop
                            }}
                            config={{
                                componentElementsOrderConfig
                            }}
                        />
                    )
                );
            default:
                return (
                    <CollectionItem collectionItem={CollectionItemType.TOUT} id={gridItem.itemId} />
                );
        }
    }
}
